import {
  descriptionUI,
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { MedicareLearnMoreDescription } from '../../../components/FormDescriptions';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['insurance-info--medicare-enrollment-title'];
const DESC_TEXT = content['insurance-info--medicare-enrollment-description'];
const INPUT_LABEL = content['insurance-info--medicare-enrollment-label'];

const { isEnrolledMedicarePartA } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    ...descriptionUI(MedicareLearnMoreDescription),
    isEnrolledMedicarePartA: yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['isEnrolledMedicarePartA'],
    properties: { isEnrolledMedicarePartA },
  },
};
